var _excluded = ["categoryId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { Carousel } from "../../../internal/Carousel/Carousel";
import { CarouselItem } from "../../../internal/Carousel/CarouselItem";
import { CategoryCard } from "./CategoryCard";
import { useGridColumnGap } from "../../../../hooks/useGridColumnGap";
export var CategoryCarousel = function CategoryCarousel(_ref) {
  var categories = _ref.categories,
    lazyImages = _ref.lazyImages,
    onCategoryClick = _ref.onCategoryClick,
    onNavigation = _ref.onNavigation,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    title = _ref.title;
  var columnGap = useGridColumnGap();
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  var categoriesLength = categories.length;
  return /*#__PURE__*/React.createElement("div", {
    ref: observedElementRef
  }, /*#__PURE__*/React.createElement(Carousel, {
    columnGap: columnGap,
    onNavigateLeft: function onNavigateLeft(_ref2) {
      var swiped = _ref2.swiped;
      return onNavigation === null || onNavigation === void 0 ? void 0 : onNavigation(swiped, 'prev');
    },
    onNavigateRight: function onNavigateRight(_ref3) {
      var swiped = _ref3.swiped;
      return onNavigation === null || onNavigation === void 0 ? void 0 : onNavigation(swiped, 'next');
    },
    title: title
  }, categories.map(function (category, index) {
    var categoryId = category.categoryId,
      restOfCategoryData = _objectWithoutProperties(category, _excluded);
    return /*#__PURE__*/React.createElement(CarouselItem, {
      ariaLabel: "slide ".concat(index + 1, " of ").concat(categoriesLength),
      key: categoryId
    }, /*#__PURE__*/React.createElement(CategoryCard, _extends({
      lazyImages: lazyImages
    }, restOfCategoryData, {
      onLinkClick: function onLinkClick(e) {
        return onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick(e, {
          index
        });
      }
    })));
  })));
};